import { ChangeEvent, FC } from 'react';
import { CustomSearchInput } from '@mybonum/ui';
import { useSearchParams } from 'react-router';
import { useDebouncedCallback } from 'use-debounce';

import { TSearchProps } from './types';

import { URL_PARAMS } from '@/constants/url-params.ts';

export const Search: FC<TSearchProps> = (props) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const handleSearch = useDebouncedCallback((event: ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value.trim();
        const updatedSearchParams = new URLSearchParams(searchParams.toString());

        if (value) {
            updatedSearchParams.set(URL_PARAMS.SEARCH, value);
        } else {
            updatedSearchParams.delete(URL_PARAMS.SEARCH);
        }

        setSearchParams(updatedSearchParams);
    }, 600);

    return (
        <CustomSearchInput
            {...props}
            defaultValue={searchParams.get(URL_PARAMS.SEARCH) || ''}
            onChange={handleSearch}
        />
    );
};
